module.exports = __webpack_public_path__ + "img/14.fa7497c.svg";